import React from 'react'
import { browserHistory } from 'react-router'
import Datagrid from '../../Component/Demande/index'

class Search extends React.Component {

  constructor(props) {
    super(props)
    console.log(this.props.route && this.props.route.type)
  }

  render = _ => <Datagrid key={this.props.route && this.props.route.type} name={this.props.route && this.props.route.type} type={this.props.route && this.props.route.type} />
}

export default Search





// WEBPACK FOOTER //
// ./app/App/Module/Restaurant/Page/Demande/index.js